import loadable from '@loadable/component';

export const ImportedListingPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ImportedListingPageContainer" */
      './ImportedListingPageContainer.dynamic'
    ),
);
